<template>
  <div class="page-login">
    <header class="login-hero" aria-label="登錄頁頂部">
      <div class="login-hero__banner">
        <img
          class="login-hero__banner-img"
          :src="toppicImg"
          width="100%"
          alt=""
        />
        <!-- 若頂圖資源已含「員工考勤系統」字樣，將 showHeroTitle 設為 false -->
        <p v-if="showHeroTitle" class="login-hero__title">員工考勤系統</p>
      </div>
    </header>
    <form id="form_login" name="form_login" @submit.prevent>
      <div class="login-form-stack">
      <div class="mainBox mainBox--card">
        <ul>
          <li class="login-combined">
            <div class="login-combined__field">
              <span class="username">用户名</span>
              <label>
                <input
                  id="loginName"
                  v-model="formData.loginName"
                  type="text"
                  name="loginName"
                  class="text"
                  placeholder="請輸入您的用戶名"
                  autocomplete="off"
                  data-issubmit="1"
                />
              </label>
            </div>
            <div class="login-combined__divider"></div>
            <div class="login-combined__field">
              <span class="passwork">密&nbsp;&nbsp;码</span>
              <label>
                <input
                  id="loginPwd"
                  v-model="formData.loginPwd"
                  type="password"
                  name="loginPwd"
                  class="text"
                  placeholder="請輸入您的密碼"
                  autocomplete="off"
                  data-issubmit="1"
                />
              </label>
            </div>
          </li>
<!--          <li v-if="useMemberRest" class="login-captcha-li">
            <span class="number login-captcha-li__label">驗證碼</span>
            <div class="login-captcha-mobi-wrap">
              <div class="login-captcha-mobi" role="group" aria-label="驗證碼">
                <input
                  id="ValidateCode"
                  v-model="formData.ValidateCode"
                  type="text"
                  inputmode="text"
                  maxlength="8"
                  name="ValidateCode"
                  class="text login-captcha-mobi-input"
                  placeholder="請輸入右側字符"
                  autocomplete="off"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  data-issubmit="1"
                />
                <button
                  type="button"
                  class="login-captcha-mobi__thumb"
                  :class="{ 'login-captcha-mobi__thumb&#45;&#45;busy': captchaLoading }"
                  :aria-busy="captchaLoading ? 'true' : 'false'"
                  :aria-label="captchaLoading ? '驗證碼載入中' : '點擊刷新驗證碼'"
                  @click="refreshCaptcha"
                >
                  <template v-if="captchaLoading">
                    <span class="login-captcha-mobi__loading" aria-hidden="true" />
                    <span class="login-captcha-mobi__state login-captcha-mobi__state&#45;&#45;loading">載入中</span>
                  </template>
                  <template v-else>
                    <img v-if="captchaObjectUrl" :src="captchaObjectUrl" alt="" />
                    <span v-else class="login-captcha-mobi__state">點圖載入</span>
                  </template>
                </button>
                <button
                  type="button"
                  class="login-captcha-mobi__refresh"
                  :disabled="captchaLoading"
                  aria-label="換一張驗證碼"
                  @click="refreshCaptcha"
                >
                  換一張
                </button>
              </div>
              <p class="login-captcha-mobi__hint">看不清？點擊圖片或「換一張」刷新</p>
              <p v-if="captchaError" class="login-captcha-mobi__err" role="alert">{{ captchaError }}</p>
            </div>
          </li>-->
        </ul>
        <div class="clear"></div>
      </div>
      <div class="mainBox mainBox--btn">
        <button
          id="btnSubmit"
          type="button"
          name="btnSubmit"
          class="btn"
          @click="onSubmit"
        >
          登 錄
        </button>
      </div>
      </div>
    </form>
  </div>
</template>

<script>
import '@/assets/css/Login.css'
import toppicImg from '@/assets/images/Mobi/toppic.33c6e1bf.jpg'
import * as memberRest from '../api/memberRestApi'

export default {
  name: 'Login',
  data() {
    return {
      /** 頂圖不含「員工考勤系統」時改為 true；已印在圖上請保持 false 避免重字 */
      showHeroTitle: false,
      toppicImg,
      captchaObjectUrl: '',
      captchaLoading: false,
      captchaError: '',
      formData: {
        loginName: '',
        loginPwd: '',
        ValidateCode: ''
      }
    }
  },
  computed: {
    /**
     * 是否走 /member/login 並顯示驗證碼。
     * 打包時若未注入 VUE_APP_*，原先會判成 false 導致頁面沒有驗證碼——故僅在顯式關閉時為 false，其餘默認為 true。
     * 純本地演示不調接口：在 .env 設 VUE_APP_USE_MEMBER_REST=0
     */
    useMemberRest() {
      const env = typeof process !== 'undefined' && process.env ? process.env : {}
      const raw = env.VUE_APP_USE_MEMBER_REST
      const flag = raw == null || raw === '' ? '' : String(raw).trim().toLowerCase()
      if (flag === '0' || flag === 'false' || flag === 'off') return false
      return true
    }
  },
  mounted() {
    if (this.useMemberRest) {
      // this.refreshCaptcha()
    }
  },
  beforeDestroy() {
    this.revokeCaptchaObjectUrl()
  },
  methods: {
    revokeCaptchaObjectUrl() {
      if (this.captchaObjectUrl && String(this.captchaObjectUrl).indexOf('blob:') === 0) {
        try {
          URL.revokeObjectURL(this.captchaObjectUrl)
        } catch (e) {
          void e
        }
      }
      this.captchaObjectUrl = ''
    },
    async refreshCaptcha() {
      if (!this.useMemberRest) return
      this.captchaError = ''
      this.captchaLoading = true
      this.revokeCaptchaObjectUrl()
      try {
        const blob = await memberRest.fetchMemberCaptchaBlob()
        this.captchaObjectUrl = URL.createObjectURL(blob)
      } catch (e) {
        console.warn('[Mobi Login] fetchMemberCaptchaBlob', e)
        const msg = (e && e.message) || '驗證碼載入失敗'
        try {
          this.captchaObjectUrl = memberRest.getMemberCaptchaImgSrc()
          this.captchaError = ''
        } catch (e2) {
          void e2
          this.captchaError = msg
        }
      } finally {
        this.captchaLoading = false
      }
    },
    async onSubmit() {
      const name = (this.formData.loginName || '').trim()
      const pwd = (this.formData.loginPwd || '').trim()
      if (!name || !pwd) {
        await this.$postNotify({ type: 'warning', message: '請輸入完整的登錄信息！' })
        return
      }
     /* if (this.useMemberRest && !(this.formData.ValidateCode || '').trim()) {
        await this.$postNotify({ type: 'warning', message: '請輸入驗證碼' })
        return
      }*/
      if (this.useMemberRest) {
        try {
          const loginResult = await memberRest.memberLogin({
            account: name,
            password: pwd,
            // code: (this.formData.ValidateCode || '').trim(),
          })
          try {
            localStorage.setItem('mobi_login_name', name)
          } catch (e) { /* ignore */ }
          if (loginResult.needChangePassword) {
            alert('您的賬戶為初次登錄 或 密碼由後臺重新設定，為安全起見請設定 ‘新密碼’。');
            this.$router.push({ name: 'MobiChangePassword', query: { user: name, first: '1' } })
            return
          }
          {
            let frozen = false
            try {
              const ld = loginResult.data
              const md = (ld && (ld.member || ld.user || ld.account)) || ld
              if (md && (md.status == 1 || md.g_lock == 1 || md.frozen == 1)) frozen = true
            } catch (e) { /* ignore */ }
            if (!frozen) {
              try {
                const info = await memberRest.memberInfo({})
                const md = info.member || info.user || info
                if (md && (md.status == 1 || md.g_lock == 1)) frozen = true
              } catch (e) {
                if (typeof console !== 'undefined' && console.warn) console.warn('[Login] memberInfo', e)
              }
            }
            if (frozen) {
              try { localStorage.setItem('mobi_account_frozen', '1') } catch (e) { /* ignore */ }
              alert('账号被冻结！')
              this.$router.push({ name: 'MobiMain', query: { user: name } })
              return
            }
            try { localStorage.removeItem('mobi_account_frozen') } catch (e) { /* ignore */ }
          }
        } catch (e) {
          this.formData.ValidateCode = ''
          // await this.refreshCaptcha()
          await this.$postNotify({ type: 'error', message: (e && e.message) || '登錄失敗' })
          return
        }
      } else {
        try {
          localStorage.setItem('mobi_login_name', name)
        } catch (e) {
          /* ignore */
        }
      }
      this.$router.push({ name: 'MobiMain', query: { user: name } })
    }
  }
}
</script>
